import { render, staticRenderFns } from "./WeChatLogin.vue?vue&type=template&id=f1e34d60&scoped=true"
import script from "./WeChatLogin.vue?vue&type=script&lang=js"
export * from "./WeChatLogin.vue?vue&type=script&lang=js"
import style0 from "./WeChatLogin.vue?vue&type=style&index=0&id=f1e34d60&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1e34d60",
  null
  
)

export default component.exports